import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

async function normalizarParaSalvar(solicitacao) {
  for (var i = 0; i < solicitacao.solicitacaoPagamentoRateio.length; i++) {
      delete solicitacao.solicitacaoPagamentoRateio[i].projeto; 
      delete solicitacao.solicitacaoPagamentoRateio[i].projetoMetaEtapa; 
      delete solicitacao.solicitacaoPagamentoRateio[i].detalheRateio;
      delete solicitacao.solicitacaoPagamentoRateio[i].solicitacaoPagamento;
      delete solicitacao.solicitacaoHasSolicitacao[i].solicitacoesPagamento;
  }

  delete solicitacao.solicitacao.rateio.projeto;
  delete solicitacao.solicitacao.rateio.projetoMetaEtapa;
  delete solicitacao.solicitacao.rateio.detalheRateio;
  

  delete solicitacao.solicitacao.solicitante;
  delete solicitacao.solicitacao.protocolo;
  delete solicitacao.solicitacao.rubrica;
  delete solicitacao.solicitacao.subrubrica;
  delete solicitacao.solicitacao.conta;
  
  if (solicitacao.solicitacao.dataPagamento) {
      solicitacao.solicitacao.dataPagamento = await formatarData.paraNumero(solicitacao.solicitacao.dataPagamento);
  }
  if (solicitacao.solicitacao.dataNascimento) {
      solicitacao.solicitacao.dataNascimento = await formatarData.paraNumero(solicitacao.solicitacao.dataNascimento);
  }
  if (solicitacao.solicitacao.dataEmissao) {
      solicitacao.solicitacao.dataEmissao = await formatarData.paraNumero(solicitacao.solicitacao.dataEmissao);
  }
  if (solicitacao.solicitacao.dataVencimento) {
      solicitacao.solicitacao.dataVencimento = await formatarData.paraNumero(solicitacao.solicitacao.dataVencimento);
  }

  return solicitacao;
}

function normalizarParaVisualizar(solicitacao) {

  for (var i = 0; i < solicitacao.solicitacaoPagamentoRateio.length; i++) {
      solicitacao.solicitacaoPagamentoRateio[i].valorRateio = converterMoeda.paraReal(solicitacao.solicitacaoPagamentoRateio[i].valorRateio);
  }

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);
    
    const periodo = parametros.periodo;
    delete parametros.periodo;
    
    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaopagamentosrateio', { params: parametros });
  },
  adicionar: async (solicitacao, arquivos) => {
    solicitacao = await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = await converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaopagamentosrateio', solicitacao).then(res => res.data.id);
  },
  alterar: async (solicitacao, arquivos, id) => {
    solicitacao = await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;
    
    solicitacao = await converterObjetoFormData(solicitacao);
    
    return Vue.http.put(`/api/solicitacaopagamentosrateio/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaopagamentosrateio/${id}`)
      .then(response => response.data)
      .then(solicitacao => normalizarParaVisualizar(solicitacao));
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaopagamentosrateio/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaopagamentosrateio/${id}/cancelar`)
      .then(response => response.data);
  },
  reenviarEmail: id => {
    return Vue.http.get(`/api/solicitacaopagamentosrateio/${id}/reenviaremail`)
      .then(response => response.data);
  },
  arquivos: id => {
      return Vue.http.get(`/api/solicitacaopagamentosrateio/${id}/arquivos`)
          .then(response => response.data);
  },
  download: (id, arquivo) => {
      return Vue.http.get(`/api/solicitacaopagamentosrateio/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-pagamento-rateio/servico.js